import { Injectable } from '@angular/core';
@Injectable()
export class HostService {
  host = "https://api.helpyfood.com/api/website2/"
  host2 = "https://api.helpyfood.com"

  // host = "https://api.restocall.fr/api/website2/"
  // host2 = "https://api.restocall.fr/"
  // host = "https://api.restocall.com/api/website2/"
  // host2 = "https://api.restocall.com"
  // host="http://192.168.1.104:8000/api/"
  // host2="http://192.168.1.104:8000/"
}





// WEBPACK FOOTER //
// ./src/providers/host/host.service.ts